export enum MemberUpdateTypeEnum {
  Update = 1,
  NewMember = 2,
}
